import React, { useContext, useState, useEffect } from 'react';
import { StateContext } from '../../Util/StateContext/StateContext';
import SearchFilter from './SearchFilter/SearchFilter';
import SelectFieldFilter from './SelectField/SelectFieldFilter';


const Filtering = (props) => {
    const { state, dispatch } = useContext(StateContext);
    const [selectedFilters, setSelectedFilters] = useState(state.selectedFilters);
    const [searchTerm, setSearchTerm] = useState(state.searchTerm);

    useEffect(() => { 
        dispatch({ type: "SET_SELECTED_FILTERS", payload: selectedFilters });
        dispatch({ type: "SET_SEARCH_TERM", payload: searchTerm });
    }, [selectedFilters, searchTerm, dispatch]);



    const setSearch = (value) => {
        setSearchTerm(value);
        dispatch({ type: "SET_PAGED_NUMBER", payload: 1 });
        dispatch({ type: "SET_ORDERBY", payload: "root_part_numbers" });
        dispatch({ type: "SET_ORDER", payload: "ASC" });
        
    }

    //TODO: Add filter for reducer
    const updateSelection = (key, value) => {
        setSelectedFilters({ ...selectedFilters, [key]: value });
        dispatch({ type: "SET_PAGED_NUMBER", payload: 1 });
    }

    const clearFilters = () => {
        let clearObj = {};
        Object.keys(state.filterOptions).map((key, option) => {
            clearObj[key] = "All";
            return clearObj;
        })
        setSelectedFilters(clearObj);
        setSearchTerm("");
        dispatch({ type: "SET_ORDER", payload: "" });

    }

    // const checkIfUndefined = (value) => {
    //     return typeof value === "undefined" || value === null;
    // }

    return (
        <div id="filtering" className={props.showFilters ? "is-open" : ""}>
            {state.filterOptions &&
                (
                    <div className="filter-box">
                        <button
                            onClick={() => clearFilters()} 
                            className="clear-filters"
                            aria-label={"Clear all filters"}
                            >
                            <p>Clear Filters</p>
                        </button>
                        <SearchFilter
                            searchTerm={searchTerm}
                            setSearchTerm={setSearch}
                        ></SearchFilter>
                        <div className={`filter-options ${props.showFilters ? "open" : ""}`}>
                            {Object.keys(state.filterOptions).map((key, option) => {
                                return (
                                    <div key={key} className="filter-wrapper">
                                        <SelectFieldFilter
                                            currentSelection={selectedFilters[key]}
                                            callback={(key, value) => updateSelection(key, value)}
                                            label={state.filterOptions[key].label}
                                            filterKey={key}
                                            options={state.filterOptions[key].options}
                                        >
                                        </SelectFieldFilter>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div>

                )
            }
        </div>
    )
}

export default Filtering;